import Api from './BaseRequest';

const Get = () => {
    return Api.Get('/api/tcElementQuestions');
};

const GetOld = () => {
    return Api.Get('/api/tcElementQuestions/old');
};

const updateAnswers = (data) => {
    return Api.Post('/api/tcElementQuestions/updateAnswers', data);
}

const updateAnswer = (data) => {
    return Api.Post('/api/tcElementQuestions/updateAnswer', data);
}

export default {
    Get,
    GetOld,
    updateAnswers,
    updateAnswer,
};
